import { render, staticRenderFns } from "./MainBookCompIndex.vue?vue&type=template&id=5ada3f5f&scoped=true"
import script from "./MainBookCompIndex.vue?vue&type=script&lang=js"
export * from "./MainBookCompIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada3f5f",
  null
  
)

export default component.exports